import { gql } from '@apollo/client';


export const ADD_OR_UPDATE_AXLE_IN_AXLE_GROUP = gql`
mutation addOrUpdateAxleInAxleGroup($input: AddOrUpdateAxleInAxleGroupInput!) {
  addOrUpdateAxleInAxleGroup(input: $input) {
    clientMutationId
    errors
    axleGroup {
      id
      name
      weight
      overLimit
      leftSubtotal
      rightSubtotal
      subtotal
      axles {
        id
        name
        leftAxleWeight
        rightAxleWeight
        totalAxleWeight
      }
      axleGroupType {
        id
        name
        weightLimit
      }
      axleGroupLimit
    }
    axle {
      id
      name
    }
  }
}
`